<template>
  <MenuPopup class="min-w-188px">
    <MenuPopupItem v-for="(portfolio,i) in portfolios_list.data" :key="i"
                   @click.native="changeCurrentPortfolio(portfolio)"
                   :active="portfolio.id === current_portfolio.data.id"
                   :mute-inactive="true">
      <template slot="icon"><IconWallet/></template>
      <template slot="text">{{ portfolio.name }}</template>
    </MenuPopupItem>
  </MenuPopup>
</template>

<script>
import IconRoundTick from "@/components/icons/IconRoundTick";
import IconWallet from "@/components/icons/IconWallet";
import {mapActions, mapState} from "vuex";
import MenuPopup from "@/components/common/MenuPopup/MenuPopup";
import MenuPopupItem from "@/components/common/MenuPopup/MenuPopupItem";

export default {
  name: "HeaderPortfoliosNavigationPopup",
  components: {MenuPopupItem, MenuPopup, IconRoundTick, IconWallet},
  computed: {
    ...mapState('cabinet/user', ['user_info']),
    ...mapState('investments/portfolios', ['current_portfolio', 'portfolios_list'])
  },
  methods: {
    ...mapActions('cabinet/user', ['setUserPrimarySpaceId']),
    changeCurrentPortfolio(portfolio) {
      this.$emit('hide');
      this.$cookies.set('active_invest_portfolio', portfolio.id)
      this.$store.commit('investments/portfolios/setActivePortfolio', portfolio)
    }
  }
}
</script>